module.exports = __webpack_public_path__ + "img/TumiBackground.0b2f6157.jpg";